import styled from "styled-components";

export const DropdownListPortalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9000;
  /* pointer-events: none; */
`;
